import { render, staticRenderFns } from "./Mirror.vue?vue&type=template&id=4f549b8e&scoped=true&"
import script from "./Mirror.vue?vue&type=script&lang=js&"
export * from "./Mirror.vue?vue&type=script&lang=js&"
import style0 from "./Mirror.vue?vue&type=style&index=0&id=4f549b8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f549b8e",
  null
  
)

export default component.exports